
import axios, { AxiosError, AxiosInstance } from 'axios';
import ErrorResponse from './../../../src/error-response';

import * as ServerData from './../../server-data';

export default class MyClientFileWriterService {

   public static registerAndAddClientFileToMyQ(
           axiosInstance: AxiosInstance, input: ServerData.MyClientFileWebWriter.RegisterAndAddClientFileToMyQ$Input,
           f: (output: ServerData.MyClientFileWebWriter.RegisterAndAddClientFileToMyQ$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            data : input.toJson()

         };
        return axiosInstance.post(
            'spineapi/myclientfile/register-and-add-client-file-to-my-q',
            input.toJson()
        ).then((response) => ServerData.MyClientFileWebWriter.RegisterAndAddClientFileToMyQ$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


}

